export const smartFeatures = [
  {
    icon: 'link',
    title: 'Ficha de cadastro por link',
    description: 'Envie a ficha de cadastro digital e receba preenchida pelo paciente.',
    route: '/clientes',
  },
  {
    icon: 'graphic_eq',
    title: 'Transcrição por IA',
    description: 'Transcreve e resume sessões automaticamente com IA.',
    route: '/agenda',
  },
  {
    icon: 'notifications',
    title: 'Lembretes por WhatsApp',
    description: 'Enviados automaticamente após criar o agendamento.',
    route: '/agenda',
  },
  {
    icon: 'videocam',
    title: 'Sala de vídeo',
    description: 'Própria, sem limite de tempo de sessão.',
    route: '/agenda',
  },
]
